import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './producaoActions';
import Th from '../common/table/th';
import THead from '../common/table/tHead';
import Table from '../common/table/table';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Tr from '../common/table/tr';
import TBody from '../common/table/tBody';
import FormatUtils from '../common/formatUtils/FormatUtils';
import materiaPrima from '../materiaPrima/materiaPrima';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';

class ProducaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		const readOnly = this.props.excluir ? 'readOnly' : '';
		const execucao = !!this.props.formularioValues.datahora_confirmacao;

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>						
						<Row>
							{!this.props.formularioValues.id && 
							<Select
								name='id_solicitacao'
								options={this.props.listaSolicitacao}
								label='Solicitação *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly}
								value={this.props.formularioValues.id_solicitacao}
								onChange={value => {

									const solicitacao = this.props.listaSolicitacao.filter(item => item.id == value)[0];

									this.montarOrdemProducao({
										...this.props.formularioValues,
										id_solicitacao: solicitacao ? solicitacao.id : null,
										id_racao: solicitacao ? solicitacao.id_racao : null,
										quantidade: FormatUtils.formatarValorTela(solicitacao ? solicitacao.quantidade : 0, 2),
										id_unidade_medida: solicitacao ? solicitacao.id_unidade_medida : null
									});
									
								}} />}

							{!!this.props.formularioValues.id && 
							<LabelAndInput
								label='Solicitação *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'}
								value={`${this.props.formularioValues.id_solicitacao} - ${this.props.formularioValues.nome_parceiro} - ${this.props.formularioValues.nome_racao} - ${FormatUtils.formatarValorTela(this.props.formularioValues.quantidade_solicitacao, 2)} ${this.props.formularioValues.sigla_unidade_medida}`}
								onChange={() => {}} />}

							<Field
								name='id_racao'
								options={this.props.listaRacao}
								component={Select}
								label='Ração *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={execucao ? 'readOnly' : readOnly}
								title='Quantidade utilizada na fórmula'
								casas={2} />

							<Field
								name='id_unidade_medida'
								options={this.props.listaUnidadeMedida}
								component={Select}
								label='Unidade de Medida *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={300}
								readOnly={execucao ? 'readOnly' : readOnly} />

							<Select
								name='id_equipamento'
								options={this.props.listaEquipamento}
								label='Misturador *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={execucao ? 'readOnly' : readOnly}
								value={this.props.formularioValues.id_equipamento}
								onChange={value => {
									this.montarOrdemProducao({
										...this.props.formularioValues,
										id_equipamento: value
									});
									
								}} />

							<LabelAndInputDate
								label='Agendamento'
								cols='12 1 1 1'
								readOnly={execucao ? 'readOnly' : readOnly}
								value={this.props.formularioValues.data_agendamento}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_agendamento: value
									});
								}} />

							{execucao &&
							<LabelAndInputDateTime
								label='Início da Produção'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.datahora_inicio}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										datahora_inicio: value
									});
								}} />}

							{execucao &&
							<LabelAndInputDateTime
								label='Término da Produção'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.datahora_fim}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										datahora_fim: value
									});
								}} />}
						</Row>

						<Row>
							<Grid cols='12 12 12 12'>
								<label>Entrega</label>
							</Grid>
						</Row>
						<Row>
							<Select
								name='id_veiculo'
								options={this.props.listaVeiculo}
								label='Veículo' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.id_veiculo : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											id_veiculo: value
										}
									});
								}} />

							<Select
								name='id_motorista'
								options={this.props.listaMotorista}
								label='Motorista' placeholder='Informe'
								cols='12 4 4 4'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.id_motorista : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											id_motorista: value
										}
									});
								}} />

							<LabelAndInputDate
								label='Agendamento'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.data_agendamento : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											data_agendamento: value
										}
									});
								}} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

					{this.lotes()}

				</Form>
			</ContentCard>
		);
    }

	montarOrdemProducao(registro) {
		
		const racao = this.props.listaRacaoCompleta.filter(item => item.id == registro.id_racao)[0];
		const equipamento = this.props.listaEquipamentoCompleto.filter(item => item.id == registro.id_equipamento)[0];

		const quantidadeProducao = parseFloat(registro.quantidade) || 0;
		const capacidadeEquipamento = equipamento ? parseFloat(equipamento.capacidade) || 0 : 0;

		let producoes = [];
		if (racao && quantidadeProducao) {
			if (capacidadeEquipamento <= 0) {
				producoes.push({
					lote: 1,
					id_racao: registro.id_racao,
					quantidade: quantidadeProducao,
					id_unidade_medida: registro.id_unidade_medida,
					sigla_unidade_medida: racao ? racao.sigla_unidade_medida : '',
					materias_primas: []
				});
			} else {
				
				let quantidadeRestante = quantidadeProducao;
				let lote = 0;
				while (quantidadeRestante > 0) {

					const quantidade = quantidadeRestante < capacidadeEquipamento ? quantidadeRestante : capacidadeEquipamento;
					quantidadeRestante -= quantidade;
					lote++;
					
					producoes.push({
						lote: lote,
						id_racao: registro.id_racao,
						quantidade: quantidade,
						id_unidade_medida: registro.id_unidade_medida, 
						sigla_unidade_medida: racao ? racao.sigla_unidade_medida : '',
						materias_primas: []
					});
				}
			}
		}

		producoes = producoes.map(producao => {

			const materiasPrimas = (racao ? racao.itens : []).filter(materiaPrima => materiaPrima).map(materiaPrima => {
				
				const quantidadeProducao = parseFloat(producao.quantidade) || 0;
				const quantidadeRacaoFormula = racao ? parseFloat(racao.quantidade) || 0 : 0;
				const quantidadeMP = parseFloat(materiaPrima.quantidade) || 0;

				const quantidade = quantidadeRacaoFormula > 0 ? (quantidadeProducao * quantidadeMP) / quantidadeRacaoFormula : 0;				

				return {
					id: materiaPrima.id,
					id_materia_prima: materiaPrima.id_materia_prima,
					nome_materia_prima: materiaPrima.nome_materia_prima,
					id_unidade_medida: materiaPrima.id_unidade_medida,
					sigla_unidade_medida: materiaPrima.sigla_unidade_medida,
					observacao: materiaPrima.observacao,
					quantidade_formula: quantidadeMP,
					quantidade: quantidade
				}
			});						

			return {
				...producao,
				materias_primas: materiasPrimas
			}
		});

		this.props.initForm({
			...registro,
			itens: producoes
		});
	}

	lotes() {

		return (
			<>
				{(this.props.formularioValues.itens || []).map(producao => (
					<ContentCard key={producao.lote}>
						<ContentCardHeader>
							<h3 class='card-title' style={{ fontWeight: 'bold' }}>
								Batida {producao.lote}
							</h3>
							<div class='card-tools' 
								style={{ paddingRight: 12, fontWeight: 'bold' }}>
								{FormatUtils.formatarValorTela(producao.quantidade, 2)} {producao.sigla_unidade_medida}
							</div>
						</ContentCardHeader>
						<ContentCardBody>
							<Table responsive>
								<THead>
									<Tr>
										<Th width={200} alignLeft>Matéria Prima</Th>
										<Th width={100} alignRight>Quantidade</Th>
										<Th width={10} alignLeft></Th>
										<Th width={300} alignCenter>Observação</Th>
									</Tr>
								</THead>
								<TBody>
									{(producao.materias_primas || []).map(materiaPrima => (
										<Tr key={materiaPrima.id} >
											<Td alignLeft>{materiaPrima.nome_materia_prima}</Td>
											<Td alignRight>{FormatUtils.formatarValorTela(materiaPrima.quantidade, 2)}</Td>
											<Td alignLeft>{materiaPrima.sigla_unidade_medida}</Td>
											<Td alignCenter>{materiaPrima.observacao}</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</ContentCardBody>
					</ContentCard>
				))}
			</>
		);
	}

}

ProducaoForm = reduxForm({form: 'producaoForm', destroyOnUnmount: false})(ProducaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('producaoForm')(state),
	registro: state.producao.registro,
	listaParceiro: state.parceiro.listaSelect,
	listaRacao: state.racao.listaSelect,
	listaRacaoCompleta: state.racao.lista,
	listaEquipamento: state.equipamento.listaSelect,
	listaEquipamentoCompleto: state.equipamento.lista,
	listaUnidadeMedida: state.unidadeMedida.listaSelect,
	listaSolicitacao: state.producao.listaSolicitacao.filter(item => !item.id_producao).map(item => ({
		...item,
		valor: `${item.id} - ${item.nome_parceiro} - ${item.nome_racao} - ${FormatUtils.formatarValorTela(item.quantidade, 2)} ${item.sigla_unidade_medida}`
	})),
	listaVeiculo: state.veiculo.listaSelect,
	listaMotorista: state.motorista.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ProducaoForm);
